<template>
  <v-select
    :value="selected"
    :dir="isRtl ? 'rtl' : 'ltr'"
    :options="options"
    :clearable="true"
    :disabled="disabled"
    :filterable="false"
    :loading="loading"
    label="label"
    :placeholder="placeholder"
    class="w-100 ledger-account-select"
    @search="onSearch"
    @input="onInput"
  >
    <template #no-options>
      {{ loading ? $t('common.loading') : $t('noMatching') }}
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select'
import Projects from '@/api/projects/projects'
import { listFrom } from '@/utils/ledger'

const projectsApi = new Projects()

function projectLabel(project) {
  if (!project) return ''
  const name = project.name || project.title || ''
  const code = project.code || project.project_code || project.project_number || ''
  if (code && name) return `${code} — ${name}`
  return name || code || `#${project.id}`
}

export default {
  name: 'PayrollProjectSelect',
  components: { vSelect },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    project: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      options: [],
      timer: null,
    }
  },
  computed: {
    isRtl() {
      return this.$store.state.appConfig.layout.isRTL
    },
    selected() {
      if (this.value == null || this.value === '') return null
      const found = this.options.find(option => option.id === Number(this.value))
      if (found) return found
      if (this.project && Number(this.project.id) === Number(this.value)) {
        return { id: this.project.id, label: projectLabel(this.project) }
      }
      return { id: Number(this.value), label: `#${this.value}` }
    },
  },
  mounted() {
    if (this.project && this.project.id != null) {
      this.options = [{ id: this.project.id, label: projectLabel(this.project), raw: this.project }]
    }
  },
  methods: {
    onSearch(search, loading) {
      const q = (search || '').trim()
      if (q.length < 1) return
      if (loading) loading(true)
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.fetchProjects(q, loading), 300)
    },
    async fetchProjects(search, loading) {
      this.loading = true
      try {
        const res = await projectsApi.listProjects({ search, per_page: 20, page: 1 })
        const rows = listFrom(res)
        const options = rows.map(project => ({
          id: project.id,
          label: projectLabel(project),
          raw: project,
        }))
        if (this.project && !options.some(option => option.id === this.project.id)) {
          options.unshift({ id: this.project.id, label: projectLabel(this.project), raw: this.project })
        }
        this.options = options
      } catch (error) {
        this.options = this.project
          ? [{ id: this.project.id, label: projectLabel(this.project), raw: this.project }]
          : []
      } finally {
        this.loading = false
        if (loading) loading(false)
      }
    },
    onInput(option) {
      this.$emit('input', option ? option.id : null)
      this.$emit('project', option ? option.raw || null : null)
    },
  },
}
</script>
